// @ts-nocheck
import _ from 'lodash';

const getEnv = key => _.defaultTo(process.env[key], window.env[key]);

const redirectUrl = new URL(window.location.href);
redirectUrl.pathname = '/auth/callback';

export const SERVER_URL = `${getEnv('REACT_APP_API_ENDPOINT')}api/`;
export const CLIENT_ID = getEnv('REACT_APP_AUTH_CLIENT_ID');
export const RESOURCE_ID = getEnv('REACT_APP_AUTH_RESOURCE_ID');
export const REDIRECT_URL = redirectUrl.origin + redirectUrl.pathname;
export const BASE_URL = getEnv('REACT_APP_AUTH_URL');
